import { Route } from '@framework/ui';
import React from 'react';
import { OpenwebLoginPage } from './OpenwebLoginPage';

/**
 * Array con tutte le routes extra necessarie all'applicativo per
 * gestire il login con OpenWeb.
 */
export const OpenwebLoginRoutes = [
  <Route
    path={'/login/openweb/:idp' as any}
    component={OpenwebLoginPage}
    key="login-openweb"
  />,
];
